import { render, staticRenderFns } from "./WideBox.vue?vue&type=template&id=e8b74e2c&scoped=true&"
import script from "./WideBox.vue?vue&type=script&lang=js&"
export * from "./WideBox.vue?vue&type=script&lang=js&"
import style0 from "./WideBox.vue?vue&type=style&index=0&id=e8b74e2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b74e2c",
  null
  
)

export default component.exports